import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import { useNavigate } from 'react-router-dom';
import './AdminMenu.css';


var imageuser = require('../../assets/img/sicknes.png');
var imagedoctor = require('../../assets/img/specility.png');
var imagelng = require('../../assets/img/langu.png');
 const Adminmenu = () => {
    const navigate = useNavigate();

    let items: MenuItem[] = [
        {
            label: 'Dashboard', icon: 'pi pi-desktop', url: '/medi/adashboard'
        },
        {
            label: 'Hospitals', icon: 'pi pi-building', url: '/medi/hospitallist'
        },
        {
            label: 'Doctors', icon: 'pi pi-id-card', url: '/medi/doctorlist'
        },
        {
            label: 'Patients', icon: 'pi pi-users', url: '/medi/patientlist'
        },
        {
            label: 'Cases', icon: 'pi pi-book', url: '/medi/caseslist'
        },
        {
            label: 'Report', icon: '', items: [
                {
                    label: 'Supervisor ',
                    icon: 'pi pi-folder',
                    url: '/medi/supervisorreport'
                },
                {
                    label: 'Doctor',
                    icon: 'pi pi-folder',
                    url: '/medi/doctorreport',

                },
                {
                    label: 'Patient ',
                    icon: 'pi pi-folder',
                    url: '/medi/patientreports',
                }
            ]
        },
        {
            label: 'Reference Data', icon: '', items: [
                {
                    label: 'Country',
                    icon: 'pi pi-globe',
                    url: '/medi/admincountry'
                },


                {
                    icon: 'pi pi-image', // This is a placeholder if needed for compatibility; it's not displayed here.
                    template: (
                        <span onClick={() => navigate('/sicknesslist')}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src={imageuser}
                                    // alt="Sickness Icon"
                                    style={{ width: '20px', height: '20px', marginLeft: '15px', justifyContent: 'unset' }} // Adjust spacing with marginRight
                                />
                                <span style={{ marginLeft: '10px' }}>Sickness</span>
                            </div>
                        </span>
                    ),
                },
                {
                    icon: 'pi pi-image', // This is a placeholder if needed for compatibility; it's not displayed here.
                    template: (
                        <span onClick={() => navigate('/speciality')}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src={imagedoctor}
                                    // alt="Sickness Icon"
                                    style={{ width: '20px', height: '20px', marginLeft: '15px', justifyContent: 'unset' }} // Adjust spacing with marginRight
                                />
                                <span style={{ marginLeft: '10px' }}>Speciality</span>
                            </div>
                        </span>
                    ),
                },
                {
                    icon: 'pi pi-image', // This is a placeholder if needed for compatibility; it's not displayed here.
                    template: (
                        <span onClick={() => navigate('/language')}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src={imagelng}
                                    // alt="Sickness Icon"
                                    style={{ width: '20px', height: '20px', marginLeft: '15px', justifyContent: 'unset' }} // Adjust spacing with marginRight
                                />
                                <span style={{ marginLeft: '10px' }}>Language</span>
                            </div>
                        </span>
                    ),
                },



                {
                    label: 'Officers',
                    icon: '',
                    url: '/medi/officers',
                },
                {
                    label: 'plan',
                    icon: '',
                    url: '/medi/plans',
                },
                {
                    label: 'Region',
                    icon: '',
                    url: '/medi/regions',
                }
            ]
        },
        {
            label: 'Payments', icon: 'pi pi-credit-card', url: '/medi/adminpayments'

        },
        {
            label: 'Activities', url: '/medi/adminactivities'
        },




    ];

    const handleItemClick = (event: { item: { url: string } }) => {
        if (event.item.url) {
            window.location.href = event.item.url;
        }
    };
     {/*<aside className="main-sidebar" >
            <div className=" menu">
                <div className="bg-bluegray-900 font-bold border-round m-2 flex align-items-center justify-content-center">
                <PanelMenu model={items} onClick={() => handleItemClick} />

                <PanelMenu model={items} />
            </div>
            </div>
        </aside> */}

    return (
        
         <aside className="main-sidebar">
              <div className="menu">
                <div className="menu-container" style={{margin:'0px 10px'}}>
                  <PanelMenu model={items} className='p-panelmenu-header' style={{backgroundColor:'#fff'}} />
                </div>
              </div>
            </aside>
           
    );
};

export default Adminmenu;
